import React from 'react'

export default function PrivacyTitle({title}) {
    return (
        <h5 style={{textAlign:"left", margin:"2em 0 1em 0"}}> {title} </h5>
    )
}